import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { TermsDialogContent } from '@/containers/auth/terms-dialog-content';
import { SIGNUP_TERMS } from '@/constants/signup-terms';

const FOOTER_LINKS = [
  { label: '이용약관', termsIndex: 0 },
  { label: '개인정보처리방침', termsIndex: 1 },
  { label: '이벤트/프로모션 정보 선택', termsIndex: 2 },
];

const Footer = () => {
  return (
    <footer className="border-t border-gr-100 bg-gr-50 px-[60px] py-[32px]">
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-[10px]">
          <p className="text-[13px] font-medium text-gr-600">
            서클플랫폼(주) 대표 : 최영우 | 사업자 등록번호 : 557-87-02223
            (통신판매 제2022-서울강남-01773호)
          </p>
          <p className="text-[13px] text-gr-500">
            contact : support@cplat.io (02-558-2166) | 서울특별시 강남구
            테헤란로 151 6층 609호
          </p>
          <p className="text-[12px] text-gr-400">
            ⓒ {new Date().getFullYear()} circleplatform. All rights reserved.
          </p>
        </div>

        <nav>
          <ul className="flex gap-[24px] text-[13px] font-medium text-gr-500">
            {FOOTER_LINKS.map(({ label, termsIndex }) => (
              <li key={termsIndex}>
                <Dialog>
                  <DialogTrigger className="transition-colors hover:text-gr-800">
                    {label}
                  </DialogTrigger>
                  <TermsDialogContent content={SIGNUP_TERMS[termsIndex].termsContent} />
                </Dialog>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
